import React from 'react';
import { uniqueId } from 'lodash';
import ProductListItem from '../ProductCard/ProductListItem';

const ProductsViewTableGallery = (props) => {
  const { products } = props;
  const getFieldId = () => uniqueId();

  return products?.length > 0 ? (
    <div className="section">
      <div className="product-list-table-gallery">
        {products.map((product) =>
          <ProductListItem key={"pk" + product.id}  {...product} fieldId={product.quantityFieldId} />
        )}
      </div>
    </div>
  ) : null;
};

export default ProductsViewTableGallery;
